import React from 'react';
import './design-system.css';

export type ButtonTone = 'primary' | 'secondary' | 'quiet' | 'danger';

export const DsButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement> & { tone?: ButtonTone; icon?: React.ReactNode }> = ({ tone = 'secondary', icon, children, className = '', ...props }) => (
  <button className={`ds-button ds-button--${tone} ${className}`} {...props}>{icon && <span className="ds-button-icon">{icon}</span>}{children}</button>
);

export const DsBadge: React.FC<{ tone?: 'success' | 'warning' | 'neutral' | 'error'; children: React.ReactNode }> = ({ tone = 'neutral', children }) => (
  <span className={`ds-badge ds-badge--${tone}`}><span className="ds-badge-dot" />{children}</span>
);

export const DsCard: React.FC<{ title?: string; description?: string; action?: React.ReactNode; children: React.ReactNode; className?: string }> = ({ title, description, action, children, className = '' }) => (
  <section className={`ds-card ${className}`}>{(title || action) && <div className="ds-card-heading"><div>{title && <h2>{title}</h2>}{description && <p>{description}</p>}</div>{action}</div>}{children}</section>
);

export const DsField: React.FC<{ label: string; hint?: string; error?: string; children: React.ReactNode }> = ({ label, hint, error, children }) => (
  <label className={`ds-field ${error ? 'ds-field--error' : ''}`}><span className="ds-field-label">{label}</span>{children}{(error || hint) && <span className="ds-field-hint">{error || hint}</span>}</label>
);

export const DsTabs: React.FC<{ value: string; onChange: (value: string) => void; tabs: { value: string; label: string }[] }> = ({ value, onChange, tabs }) => (
  <div className="ds-tabs" role="tablist" aria-label="表示切替">{tabs.map(tab => <button key={tab.value} type="button" role="tab" aria-selected={value === tab.value} className={value === tab.value ? 'ds-tab ds-tab--active' : 'ds-tab'} onClick={() => onChange(tab.value)}>{tab.label}</button>)}</div>
);
